import { StatusBar } from 'expo-status-bar';
import { LayoutChangeEvent, StyleSheet, View } from 'react-native';

import PFPGenerator from './src/components/PFPGenerator';
import { BACKGROUND_COLOR } from './src/constants/Colors';
import { PFPGeneratorContextProvider } from './src/contexts/PFPGeneratorContext';

// This ensures that when the PFP generator is embedded in an iFrame, it never shows a scrollbar and allows the user to scroll the parent page with touch inputs on this window
document.body.style.overflow = 'hidden';

// Post a message to the parent page (on a different domain) that our app has resized, and it should adjust the iFrame's size accordingly
// Ref: https://stackoverflow.com/a/27424879
// Note we're using '*' here in spite of recommendations, as there's no security risk to just sending the scrollHeight to a parent (see https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage)
const postScrollHeightToParentWindow = (event: LayoutChangeEvent) => {
  window.parent.postMessage(
    ['onPFPGeneratorHeightChange', event.nativeEvent.layout.height],
    '*'
  );
};

export default () => (
  <View
    style={styles.container}
    onLayout={(event) => postScrollHeightToParentWindow(event)}
  >
    <StatusBar style="auto" />
    <PFPGeneratorContextProvider>
      <PFPGenerator />
    </PFPGeneratorContextProvider>
  </View>
);

const styles = StyleSheet.create({
  container: {
    backgroundColor: BACKGROUND_COLOR,
  },
});
